<template>
  <div
    class="eficiensCalculatorApp"
    :class="`eficiensCalculatorApp--${outcomeType}`"
  >
    <Step
      v-if="currentStep != null"
      :title="currentStep.title"
      :image="currentStep.image"
      :color="currentStep.color"
      :type="currentStep.type"
      :typeParameters="currentStep.typeParameters"
      :options="currentStep.options"
      :result="currentStep.result ? currentStep.result : null"
      :name="currentStep.name"
    />
    <Result v-else-if="totalSteps > 0" />
  </div>
</template>

<script>
import "normalize.css";
import Step from "./components/Step.vue";
import Result from "./components/Result.vue";

export default {
  name: "app",
  components: {
    Step,
    Result
  },
  computed: {
    outcomeType() {
      if (this.$store.getters) {
        return this.$store.getters.outcomeType;
      } else {
        return null;
      }
    },
    currentStep() {
      return this.$store.getters.currentStep;
    },
    totalSteps() {
      return this.$store.getters.totalSteps;
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: $f-main-name;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Raleway Bold"), local("Raleway-Bold"),
    url(https://fonts.gstatic.com/s/raleway/v14/1Ptrg8zYS_SKggPNwJYtWqZPANqczVs.woff2)
      format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

// Bree font
@font-face {
  font-family: $f-title-name;
  src: url("https://use.typekit.net/af/be7132/000000000000000000013389/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/be7132/000000000000000000013389/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("woff"),
    url("https://use.typekit.net/af/be7132/000000000000000000013389/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: $f-title-name;
  src: url("https://use.typekit.net/af/b5463b/00000000000000000001338b/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/b5463b/00000000000000000001338b/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("woff"),
    url("https://use.typekit.net/af/b5463b/00000000000000000001338b/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 700;
}

.eficiensCalculatorApp {
  height: auto;
  color: $c-text;
  font-family: $f-main;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  h1,
  h2 {
    font-family: $f-title;
  }
}
</style>
